var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#F5CD47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5002 28.7528C41.4726 28.7528 42.4398 29.3664 43.1764 30.5936L53.4239 47.6739C54.899 50.1265 53.7602 52.1337 50.9002 52.1337H30.1002C27.2402 52.1337 26.1014 50.1248 27.5764 47.6739L37.8239 30.5936C38.5606 29.3664 39.5278 28.7528 40.5002 28.7528ZM40.5002 25.2861C38.2538 25.2861 36.198 26.5688 34.8512 28.8065L24.6038 45.8903C23.2414 48.1592 23.0923 50.5789 24.1964 52.5289C25.3006 54.4789 27.4534 55.6004 30.1002 55.6004H50.9002C53.547 55.6004 55.7015 54.4807 56.8039 52.5307C57.9063 50.5807 57.759 48.1609 56.3966 45.892L46.1491 28.8117C44.8023 26.5688 42.7466 25.2861 40.5002 25.2861Z",
    fill: "#533F04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5004 49.1873C41.7449 49.1873 42.7537 48.1785 42.7537 46.934C42.7537 45.6895 41.7449 44.6807 40.5004 44.6807C39.2559 44.6807 38.2471 45.6895 38.2471 46.934C38.2471 48.1785 39.2559 49.1873 40.5004 49.1873Z",
    fill: "#533F04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1003 36.5336C43.1003 35.0949 41.9372 33.9336 40.5003 33.9336C40.0749 33.9341 39.6561 34.039 39.2807 34.239C38.9052 34.4391 38.5846 34.7282 38.3469 35.081C38.1093 35.4338 37.9618 35.8396 37.9175 36.2627C37.8731 36.6858 37.9333 37.1133 38.0927 37.5077C39.053 39.8928 40.5003 43.4669 40.5003 43.4669L42.9114 37.5077C43.0292 37.2079 43.1003 36.8785 43.1003 36.5336Z",
    fill: "#533F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.390361127da1c70b3b82b1d770178c7e.svg";
export { ForwardRef as ReactComponent };